<script type="text/jsx">
import { mapGetters } from 'vuex';
import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import zEduMixin from '@/plans/ZONE_EDU_PLUS/mixin';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';

export default {
  mixins: [mixin, zEduMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
  },

  methods: {
    $renderCallingPlan() {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZONE_EDU_PLUS).get();
      if (!callingPlans.length) return;

      return callingPlans.map((p) => {
        return (
          <div class="pbx-cart-part">
            {this.mx_subTitle(
              this.$t(`billing.pbx.cart_name.${p.pbxCategory}`),
              this.mx_price(p),
              p?.plan_code
            )}
            {this.mx_discount(p.plan_code)}
            {this.mx_license(p.cartInfo.selected_number, this.$t('billing.planform.unit.user'))}
            {this.mx_cycle(p.billing_cycle)}
            {this.mx_edit(p)}
          </div>
        );
      });
    },
    $renderPbxBasePlan() {
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans)[0];
      if (!pbxBasePlan) return null;

      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(this.$t('billing.pbx.calling_fee_name.pay_you_go.MC'), pbxBasePlan.amount, pbxBasePlan?.plan_code)}
          {this.mx_discount(pbxBasePlan.plan_code)}
          {this.mx_cycle(pbxBasePlan.billing_cycle)}
          {this.mx_edit(pbxBasePlan)}
        </div>
      );
    },

    mergePlans (planList) {
      if(!Array.isArray(planList)) {
        return [];
      }
      return planList.reduce((acc, cur) => {
        if(Array.isArray(cur)) {
          return [...acc, ...cur];
        }
      }, [])
    },

    renderMainTitle () {
      const callingPlans = plansof(this.getSelectedPlans).type(planTypes.ZONE_EDU_PLUS).get();
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans);
      const plans = this.mergePlans([callingPlans, pbxBasePlan]);
      return plans.map((item, index) => {
        if(!index) {
          return  this.mx_title(this.title, undefined, undefined, item.parent_category, ['text-no-capitalize'])
        }
        return <div style='display: none;'>{this.mx_title(this.title, undefined, undefined, item.parent_category, ['text-no-capitalize'])}</div>
      })
    },

    $renderPrice() {
      return (
        <div class="opc-cart-item">
          { this.renderMainTitle()}
          { this.$renderCallingPlan() }
          { this.$renderPbxBasePlan() }
        </div>
      );
    },
  },
};
</script>
